import { render } from "./EnUnit2-3.vue?vue&type=template&id=4ea20689&scoped=true"
import script from "./EnUnit2-3.vue?vue&type=script&lang=js"
export * from "./EnUnit2-3.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=4ea20689&scoped=true&lang=css"
import "../assets/css/en/Unit2-3.css?vue&type=style&index=1&id=4ea20689&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea20689"]])

export default __exports__